import { render, staticRenderFns } from "./CampaignSetupsListTable.vue?vue&type=template&id=4720539e&scoped=true"
import script from "./CampaignSetupsListTable.vue?vue&type=script&lang=js"
export * from "./CampaignSetupsListTable.vue?vue&type=script&lang=js"
import style0 from "./CampaignSetupsListTable.vue?vue&type=style&index=0&id=4720539e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4720539e",
  null
  
)

export default component.exports